 import React, { useEffect, useState } from "react";
 import { useSelector } from "react-redux";
 import { CatelougeContext } from "store/contexts/Catelouge";
 import { useTranslation } from "react-i18next";
 import { useHistory } from "react-router-dom";
 import { ACTIONS } from "config";
 import { API } from "api";
 import { UTILS, STOTE_UTILS } from "utils";
 import { CONSTANTS as C } from "config";
 import { isValidSlots } from "utils/Utils";
 import useCatalogue from "hooks/useCatalogue";
 import { errorNotification } from "utils/Utils";
 import AppButton from "components/ui/AppButton.jsx";
 import BasicInfo from "./BasicInfo"
 import Location from "./Location"
 import Delivery from "./Delivery"
 import Pickup from "./Pickup";
 import Dinein from "./Dinin"
 import AppContainer from "components/ui/AppContainer";
 
const CreateStore = ({ type = "create", onSaveAndContinue, as = "page", setCurrentMode, title = "Create Store", subTitle = "Please fill the complete information to Create Store. Once you finish setting up your store, Activate it to get orders." }) => {
   const router = useHistory();
  const { t, i18n } = useTranslation();
   const catelougeType = useCatalogue();
   const { dispatch } = React.useContext(CatelougeContext);
   const { currentLanguage } = useSelector((state) => state.LanguageSlice);
   const [store, setStore] = useState(UTILS.getDumbStoreObject());
   const [loading, setLoading] = useState(false);
   const [addStage, setAddStage] = useState(0);
   const [currencies, setCurrenies] = useState();
 
   const getCurrencyTypes = async () => {
     const userDetail = UTILS.getCurrentUser();
     const result = await API.GET_CURRENCY_TYPES({
       token: userDetail.token,
     });
     if (result && result.success === 1 && UTILS.isValidObject(["data"], result))
       setCurrenies(result.data);
     else {
     }
   };
 
   useEffect(() => {
     getCurrencyTypes();
   }, []);
 
   const handleStoreMapSection = (key, val) => {
     if (key === C.KEY_MAP_ADDRESS) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           [C.KEY_MAP_ADDRESS]: val,
         },
         errors: {
           ...prevState.errors,
           [C.KEY_MAP_ADDRESS]: "",
         },
       }));
     } else if (key === "latlng") {
       const lat = val.lat;
       const lng = val.lng;
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           storeLocation: {
             coordinates: [lat, lng],
           },
         },
         errors: {
           ...prevState.errors,
           storeLocation: {
             coordinates: ["", ""],
           },
         },
       }));
     } else if (key === C.KEY_MANUAL_ADDRESS) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           [C.KEY_MANUAL_ADDRESS]: val,
         },
         errors: {
           ...prevState.errors,
           [C.KEY_MANUAL_ADDRESS]: "",
         },
       }));
     }
   };
 
   const handleStoreInfo = (key, val) => {
     if (
       key === C.KEY_EMAIL ||
       key === C.KEY_PHONE ||
       key === C.KEY_IMAGE_URL ||
       key === C.KEY_TAX_RATE ||
       key === C.AVERAGE_PREP ||
       key === C.PICKUP_AVERAGE_PREP ||
       key === C.DINEIN_AVERAGE_PREP ||
       key === C.KEY_IS_TAX_INCLUSIVE ||
       key === C.KEY_CITY ||
       key === C.KEY_TIMEZONE ||
      key === C.KEY_WHATSAPP_PHONE ||
      key === "isAcceptQuickOrderForDelivery" ||
      key === "isPreOrderEnabledForDelivery" ||
      key === "isAcceptQuickOrderForPickup" ||
      key === "isPreOrderEnabledForPickup"
     ) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           [key]: val,
         },
         errors: {
           ...prevState.errors,
           [key]: "",
         },
       }));
     } else if (key === C.KEY_DELETE_IMG_URL) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           [key]: "",
         },
         errors: {
           ...prevState.errors,
           [key]: "",
         },
       }));
     } else {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
           [C.BASE_LANGUAGE]: {
             ...prevState.values[C.BASE_LANGUAGE],
             [key]: val,
           },
         },
         errors: {
           ...prevState.errors,
           [C.BASE_LANGUAGE]: {
             ...prevState.errors[C.BASE_LANGUAGE],
             [key]: "",
           },
         },
       }));
     }
   };
 
   const validateInputs = () => {
     let objValid = STOTE_UTILS.VALIDATE_INPUTS(store);
     if (!objValid.isFormValid) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
         },
         errors: {
           ...prevState.errors,
           ...objValid.errors,
         },
       }));
     }
     return objValid.isFormValid;
   };
 
   const getCurrencyId = () => {
     if (Array.isArray(currencies) && currencies.length > 0)
       return currencies[0]._id;
     else return null;
   };
 
   const didMount = React.useRef(false);
 
   useEffect(() => {
     if (didMount.current) {
       if (store?.values?.workingHours) {
         checkDeliveryTimeSlots(store.values.workingHours, "workingHours");
       }
     } else {
       didMount.current = true;
     }
   }, [store.values.workingHours]);
 
   useEffect(() => {
     if (didMount.current) {
       if (store?.values?.workingHoursForPickup) {
         checkDeliveryTimeSlots(
           store.values.workingHoursForPickup,
           "workingHoursForPickup"
         );
       }
     } else {
       didMount.current = true;
     }
   }, [store.values.workingHoursForPickup]);
 
   useEffect(() => {
     if (didMount.current) {
       if (store?.values?.workingHoursForDinein) {
         checkDeliveryTimeSlots(
           store.values.workingHoursForDinein,
           "workingHoursForDinein"
         );
       }
     } else {
       didMount.current = true;
     }
   }, [store.values.workingHoursForDinein]);
 
   const checkDeliveryTimeSlots = (workingHours, type) => {
     let slotCheck = isValidSlots(workingHours);
     if (!slotCheck.isFormValid) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
         },
         errors: {
           ...prevState.errors,
           [type]: {
             ...prevState.errors[type],
             ...slotCheck.errors,
           },
         },
       }));
     } else {
       setStore((prevState) => ({
         ...prevState,
         errors: {
           ...prevState.errors,
           [type]: {},
         },
       }));
     }
     return slotCheck.isFormValid;
   };
 
   const checkSlotValidation = () => {
     let slotCheck = isValidSlots(store.values.workingHours);
     if (!slotCheck.isFormValid) {
       setStore((prevState) => ({
         ...prevState,
         values: {
           ...prevState.values,
         },
         errors: {
           ...prevState.errors,
           workingHours: {
             ...prevState.errors.workingHours,
             ...slotCheck.errors,
           },
         },
       }));
     }
     return slotCheck.isFormValid;
   };
   const addStoreFunction = async () => {
     store.values.mobileNumber = await UTILS.formatPhoneNumber(
       store.values.mobileNumber
     );
     store.values.whatsAppContact = await UTILS.formatPhoneNumber(
       store.values.whatsAppContact
     );
     const storeobj = UTILS.getStoreObj(store.values);
     setLoading(true);
     const userDetail = UTILS.getCurrentUser();
  
    const apiLanguage = (currentLanguage || i18n?.language || "EN").toUpperCase();
    let s = { ...storeobj };
     s["brandId"] = userDetail.brandId;
     s["currency"] = getCurrencyId();
    s["language"] = apiLanguage;
     const result = await API.ADD_STORE({
       token: userDetail.token,
       store: s,
     });
 
     if (result?.success === 1) {
       UTILS.successNotification(
         t("Store Created Successfully, Please Add Delivery Areas!")
       );
      if (typeof onSaveAndContinue === "function" && type === "create") {
        onSaveAndContinue();
      } else {
        as === "page" ? router.goBack() : setCurrentMode("list");
      }
     } else {
       console.log({ result });
       errorNotification(
         result?.message ||
           t("We're sorry, but something went wrong. Please try again")
       );
     }
 
     dispatch({ type: ACTIONS.STORES_CHANGED });
     setLoading(false);
   };
 
   const isValidTiming = () => {
     if (
       !checkDeliveryTimeSlots(store?.values?.workingHours, "workingHours") &&
       store.values[C.ISDELIVERYENABLED]
     ) {
       UTILS.errorNotification(
         t("Please check timing in section", {
           serviceType: t("Delivery"),
         })
       );
       return false;
     }
 
     if (
       !checkDeliveryTimeSlots(
         store.values?.workingHoursForDinein,
         "workingHoursForDinein"
       ) &&
       store.values[C.ISDINEINENABLED]
     ) {
       UTILS.errorNotification(
         t("Please check timing in section", {
           serviceType: t("Contactless Dining"),
         })
       );
       return false;
     }
 
     if (
       !checkDeliveryTimeSlots(
         store?.values?.workingHoursForPickup,
         "workingHoursForPickup"
       ) &&
       store.values[C.ISPICKUPENABLED]
     ) {
       UTILS.errorNotification(
         t("Please check timing in section", {
           serviceType: t("Pickup"),
         })
       );
       return false;
     }
     return true;
   };
 
   const addStore = async () => {
     if (!validateInputs()) {
     } else if (!isValidTiming()) {
       return;
     } else {
       addStoreFunction();
     }
   };
 
   const getBuisnessType = () => {
     const userDetail = UTILS.getCurrentUser();
     return userDetail?.catalogueType;
   };

   const footer = (
     <div className="flex justify-end gap-2">
      <AppButton
         variant="outline-secondary"
         className="border border-gray-400 text-gray-700 px-4 py-2 rounded-lg"
         onClick={() => {
          as === "page" ? router.goBack() : setCurrentMode("list");
         }}
       >
         {t("Cancel")}
       </AppButton>
       <AppButton variant="primary" onClick={() => addStore()}>
         {type === "create" ? t("Save & Continue") : t("Update Store")}
       </AppButton>
       
     </div>
   );

   return (
      <AppContainer
        title={title}
        subTitle={subTitle}
        loading={loading}
        footer={footer}
      >
            <div className="flex w-full flex-col gap-0">
            <BasicInfo
              store={store}
              defaultOpen={true}
              handleValues={handleStoreInfo}
              type={type === "update" ? "update" : "create"}
            />
            <Location
              store={store}
              setStore={setStore}
              handleValues={handleStoreMapSection}
              zoom={8}
            />

            <Delivery store={store} setStore={setStore} handleStoreInfo={handleStoreInfo}/>
            
            <Pickup store={store} setStore={setStore} handleStoreInfo={handleStoreInfo}/>
            <Dinein store={store} setStore={setStore} handleStoreInfo={handleStoreInfo}/>
            </div>
            
      </AppContainer>
   );
 };
 
 export default CreateStore;
 